import { MainLayout } from '../components/MainLayout';
import { BookOpen } from 'lucide-react';

export default function TermsPage() {
  return (
    <MainLayout>
      <div className="max-w-3xl mx-auto p-4 md:p-8 space-y-6" data-testid="terms-page">
        <div className="flex items-center gap-3 mb-8">
          <BookOpen className="w-8 h-8 text-[#1e3a5f]" />
          <h1 className="text-2xl md:text-3xl font-heading font-bold text-[#1e3a5f]">Terms of Service</h1>
        </div>

        <div className="prose prose-slate max-w-none space-y-6 text-sm leading-relaxed text-slate-700">
          <p className="text-slate-500 text-xs">Last updated: March 2026</p>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">1. Agreement</h2>
            <p>By accessing OpsFlow ("the Service"), you agree to these Terms of Service. The Service is operated by FURD Ltd ("we", "us"). If you do not agree, do not use the Service.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">2. Account Responsibilities</h2>
            <p>You are responsible for maintaining the security of your account credentials. You must not share your login details. You must notify your Director immediately if you suspect unauthorised access to your account.</p>
            <p>Directors are responsible for managing team member access, including deactivating accounts when team members leave the organisation.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">3. Acceptable Use</h2>
            <p>You agree to use the Service only for legitimate business purposes related to MEP consultancy operations. You must not:</p>
            <ul className="list-disc ml-6 space-y-1">
              <li>Attempt to gain unauthorised access to other accounts or systems</li>
              <li>Upload malicious files or code</li>
              <li>Use the Service to send unsolicited communications</li>
              <li>Reverse engineer, decompile, or attempt to extract the source code</li>
              <li>Use the Service in violation of applicable laws</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">4. Data Ownership</h2>
            <p>You retain ownership of all data you enter into the Service, including enquiries, quotes, contacts, and project information. We do not claim ownership of your data.</p>
            <p>You grant us a limited licence to process your data solely for the purpose of providing the Service.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">5. Data Protection</h2>
            <p>We process personal data in accordance with UK GDPR and the Data Protection Act 2018. See our <a href="/privacy-policy" className="text-blue-600 underline">Privacy Policy</a> for details.</p>
            <p>Where AI features are used (e.g. follow-up recommendations, lead scoring), only minimised non-personal data is sent to AI providers. No client contact details, email addresses, or phone numbers are shared.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">6. Service Availability</h2>
            <p>We aim to maintain high availability but do not guarantee uninterrupted access. We may perform maintenance that temporarily affects availability. We will provide reasonable notice where possible.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">7. Limitation of Liability</h2>
            <p>The Service is provided "as is". To the fullest extent permitted by law, we shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service.</p>
            <p>Our total liability shall not exceed the fees paid by you in the 12 months preceding the claim.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">8. Termination</h2>
            <p>Either party may terminate access to the Service with 30 days written notice. Upon termination, you may request an export of your data. Data will be retained for 90 days after termination, then permanently deleted.</p>
            <p>We reserve the right to suspend accounts that violate these terms.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">9. Changes to Terms</h2>
            <p>We may update these terms. We will notify registered users of material changes via email. Continued use of the Service after changes constitutes acceptance.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">10. Governing Law</h2>
            <p>These terms are governed by the laws of England and Wales. Disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1e3a5f]">11. Contact</h2>
            <p>For questions about these terms, contact us at the address provided in the application or via your Director.</p>
          </section>
        </div>
      </div>
    </MainLayout>
  );
}
